import { render } from "./LeagueRules.vue?vue&type=template&id=b9cc526a&scoped=true"
import script from "./LeagueRules.vue?vue&type=script&scoped=true&lang=js"
export * from "./LeagueRules.vue?vue&type=script&scoped=true&lang=js"

import "./LeagueRules.vue?vue&type=style&index=0&id=b9cc526a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jgurl\\KontraWebsite\\KontraSports\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9cc526a"]])

export default __exports__